module.exports = __webpack_public_path__ + "img/micro_vs_celebrities.f1eb01c0.svg";